import { LegalLayout } from "../../components/legal/LegalLayout";
import type { LegalSection } from "../../components/legal/LegalLayout";
import { DpoLink } from "../../components/legal/DpoLink";
import { usePageMeta } from "../../hooks/usePageMeta";
import { COMPANY, NO_AFFILIATION } from "../../components/shared/Footer";

const SECTIONS: LegalSection[] = [
  {
    title: "Natureza do serviço",
    body: <p>O Gepeto é um software utilitário de geração de documentos. A plataforma organiza as informações fornecidas pelo próprio usuário em modelos de notificação extrajudicial estruturados com base na legislação vigente.</p>,
  },
  {
    title: "Ausência de mandato advocatício",
    body: (
      <>
        <p>O Gepeto não presta assessoria, consultoria jurídica privativa nem representação advocatícia, atividades reservadas à advocacia nos termos da Lei nº 8.906/94 (Estatuto da OAB).</p>
        <p>O uso da plataforma não estabelece relação cliente-advogado. Para análise individualizada do seu caso, procure um advogado de sua confiança.</p>
      </>
    ),
  },
  {
    title: "Responsabilidades do usuário",
    body: <p>O usuário é responsável pela veracidade, exatidão e completude dos dados informados, bem como pela decisão de emitir e enviar o documento gerado.</p>,
  },
  {
    title: "Resultados",
    body: <p>A notificação extrajudicial formaliza uma manifestação de vontade e documenta a comunicação. O Gepeto não garante resultado específico, pois o desfecho depende das circunstâncias do caso e da conduta da parte notificada.</p>,
  },
  {
    title: "Proteção de dados",
    body: <p>O tratamento de dados pessoais observa a Lei nº 13.709/2018 (LGPD), com compromisso de expurgo dos dados contratuais após o envio do documento, conforme detalhado na Política de Privacidade.</p>,
  },
  {
    title: "Contato e identificação",
    body: <p data-testid="termos-identificacao">Fornecedor: {COMPANY.razaoSocial} (nome fantasia {COMPANY.nomeFantasia}) — CNPJ {COMPANY.cnpj}. Endereço: {COMPANY.endereco}. Contato: <DpoLink testId="termos-contact-email" />.</p>,
  },
  {
    title: "Ausência de vínculo",
    body: <p data-testid="termos-no-affiliation">{NO_AFFILIATION}</p>,
  },
];

export default function TermosPage() {
  usePageMeta(
    "Termos de Uso | Gepeto",
    "Termos de Uso do Gepeto: software utilitário de geração de documentos extrajudiciais, sem mandato advocatício (Lei nº 8.906/94).",
  );
  return <LegalLayout testId="termos-page" eyebrow="Documento legal" title="Termos de Uso" updatedAt="setembro de 2026" sections={SECTIONS} />;
}
